import React, { useEffect, useRef, useState } from "react"
import { useParams, withRouter } from "react-router-dom"
import { connect, useSelector } from "react-redux"
import {
  Row,
  Col,
  UncontrolledTooltip,
  Container,
  Card,
  CardBody,
  Table,
  Button,
  CardHeader,
  Input,
  Label,
} from "reactstrap"
import Select from "react-select"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import Collapse from "react-bootstrap/Collapse"
import { isEmpty } from "lodash"
import { MultiSelect } from "react-multi-select-component"
import moment from "moment"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import api from "helpers/Api"

//Components

import equipmentAction from "../../store/ZXF1aXBtZW50X/actions"
import { ToastContainer, toast } from "react-toastify"
import SimpleReactValidator from "simple-react-validator"
// import * as salesAction from "../../store/c2FsZXM/actions"

const EquipmentScheduling = (props) => {
  const { dispatch, clientProfile, modeMenu } = props
  const { id } = useParams()

  //Validator
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  console.log(clientProfile, "clientProfile")
  const record = { leadId: id }
  useEffect(() => {
    dispatch(equipmentAction.loadEquipmentScheduling(record))
    dispatch(equipmentAction.loadRecordsMetaData())
    api
      // .post("get_all_equipment_type", { status: "active" })
      .post("get_all_equipment_type", { status: "active", forEC: true })
      .then((res) => {
        setEquipmentArrayDetails(res.data.data)
        res.data
      })
  }, [])

  const update = useSelector((state) => state.equipment_scheduling)

  // const salesUpdate = useSelector((specificstate) => specificstate.sales)

  const {
    equipment_scheduling = [],
    recordsMetaData = {},
    equipment_vacancy_details = [],
    equipment_office_details = [],
  } = update

  const branchOptions = !isEmpty(recordsMetaData.branchOptions)
    ? recordsMetaData.branchOptions.filter(
        (data) => data.companyCode === "ZGP" || data.companyCode === "zgp"
      )
    : []
  // const { employee_list = [] } = salesUpdate

  console.log(branchOptions, "branchOptions")

  console.log(equipment_scheduling, "equipment_scheduling")
  console.log(equipment_vacancy_details, "equipment_vacancy_details")
  console.log(equipment_office_details, "equipment_office_details")
  console.log(recordsMetaData, "recordsMetaData")

  console.log(update, "update")

  //State Handler
  const [historyModal, setHistoryModal] = useState(false)
  const handleHistoryModal = () => setHistoryModal(false)
  const [open, setOpen] = useState(false)
  const [fullscreen, setFullscreen] = useState(false)
  //Service history
  const [serviceHistoryDetails, setServiceHistoryDetails] = useState("")
  const [serviceHistoryModal, setServiceHistoryModal] = useState(false)
  const handleServiceHistoryClose = () => setServiceHistoryModal(false)

  //Collapse details
  const [collapseDetails, setCollapseDetails] = useState("")
  const [tableFilterOpt, setTableFilterOpt] = useState([])
  const [equipmentArrayDetails, setEquipmentArrayDetails] = useState("")
  const [equipmentMasterDetails, setEquipmentMasterDetails] = useState("")
  const [equipmentArrayList, setEquipmentArrayList] = useState("")
  const [eventSameModal, setEventSameModal] = useState(false)
  const handleEventSameModal = () => setEventSameModal(false)
  const [equipmentSearchDetails, setEquipmentSearchDetails] = useState("")

  const [oddEquipmentData, setOddEquipmentData] = useState([])
  const [evenEquipmentData, setEvenEquipmentData] = useState([])
  const [equipmentDataSet, setEquipmentDataSet] = useState(false)
  //state handler end
  console.log(equipmentSearchDetails, "equipmentSearchDetails")
  //Collapse Data
  const collapseData =
    !isEmpty(equipment_scheduling) && equipment_scheduling.length > 0
      ? equipment_scheduling
      : []

  console.log(collapseDetails, "collapseDetails")
  //Commit options
  const commitOptions = !isEmpty(collapseData)
    ? collapseData.map((data) => {
        if (collapseDetails.eventId !== data.eventId) {
          return {
            label: data.eventNo,
            value: data.eventId,
          }
        }
      })
    : []
  console.log(equipmentSearchDetails, "equipmentSearchDetails")
  //Event same as options
  const eventSameOptions =
    !isEmpty(commitOptions) && commitOptions.length > 0
      ? commitOptions.filter((data) => data !== undefined)
      : []
  console.log(commitOptions, "commitOptions")
  console.log(eventSameOptions, "eventSameOptions")
  console.log(equipmentArrayDetails, "equipmentArrayDetails")

  useEffect(() => {
    if (open === true) {
      setTableFilterOpt([])
    }
  }, [open])

  //Event Time

  const eventStartTimeData = moment(collapseDetails.startTime, [
    "HH.mm",
  ]).format("hh:mm a")
  const eventEndTimeData = moment(collapseDetails.endTime, ["HH.mm"]).format(
    "hh:mm a"
  )
  const crewAssemblyTimeData = moment(collapseDetails.crewAssemblyTime, [
    "HH.mm",
  ]).format("hh:mm a")

  console.log(
    eventStartTimeData,
    eventEndTimeData,
    crewAssemblyTimeData,
    "crewAssemblyTimeData"
  )

  // const [multiSelect, setMultiSelect] = useState(false)

  useEffect(() => {
    if (eventSameModal === false && tableFilterOpt.length > 0) {
      const equipmentDataList = collapseData.map((data) => {
        if (data.eventNo === tableFilterOpt[0].label) {
          return data.equipmentScheduleDetails
        }
      })
      const equipmentEventSameOptions = !isEmpty(equipmentDataList)
        ? equipmentDataList.filter((data) => data !== undefined)
        : []
      console.log(equipmentEventSameOptions, "tableFilterOpt")
      setEquipmentArrayList(equipmentEventSameOptions[0])
      // setTimeout(()=> {
      //   setEventSameAsModal(false)
      // }, 2000)
    }
  }, [eventSameModal])

  console.log(eventSameModal, "eventSameModal")

  if (
    equipmentArrayDetails &&
    equipmentArrayDetails.length > 0 &&
    !equipmentDataSet
  ) {
    // setServiceDetailData(serviceDetails)
    setEquipmentDataSet(true)

    var array = equipmentArrayDetails
    var evenServiceArray = []
    var oddServiceArray = []

    for (var i = 0; i < array.length; i++) {
      if (i % 2 == 0) {
        oddServiceArray.push(array[i])
      } else {
        evenServiceArray.push(array[i])
      }
    }
    setOddEquipmentData(oddServiceArray)
    setEvenEquipmentData(evenServiceArray)
  }

  //Final Commit
  const [tableFilterOptions, setTableFilterOptions] = useState([])
  const [eventFinalCommitModal, setEventFinalCommitModal] = useState(false)
  const finalCommitArray = !isEmpty(collapseData)
    ? collapseData.map((data) => {
        if (data.isCommitted == false) {
          return {
            label: data.eventNo,
            value: data.event_id,
          }
        }
      })
    : []
  const finalCommitOptions = !isEmpty(finalCommitArray)
    ? finalCommitArray.filter((data) => data !== undefined)
    : []
  const handleFinalEventCommitModal = () => setEventFinalCommitModal(false)

  //Final commit api section
  const [finalCommitValidation, setFinalCommitValidation] = useState(false)
  const eventFinalCommit = () => {
    var equipmentCommit = {
      leadId: id,
      eventId: tableFilterOptions.map((data) => data.value),
    }

    dispatch(equipmentAction.equipmentFinalCommit(equipmentCommit))
    setTimeout(() => {
      dispatch(equipmentAction.loadEquipmentScheduling({ leadId: id }))
      toast.success("Records Committed Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      setEventFinalCommitModal(false)
      setTableFilterOptions([])
    }, 1500)
  }

  //Single event commit section
  const [eventId, setEventId] = useState("")
  const [finalCommitModal, setFinalCommitModal] = useState(false)

  const handleFinalCommitModal = () => setFinalCommitModal(false)

  //Equipment details data
  const [renderPage, setRenderPage] = useState(false)
  const [removeEquipment, setRemoveEquipment] = useState(false)
  const [serviceList, setServiceList] = useState("")
  const [scheduleValue, setScheduleValue] = useState("")
  const [equipmentType, setEquipmentType] = useState("")
  const [vacancyIndex, setVacancyIndex] = useState("")
  const [selectedAgentData, setSelectedAgentData] = useState("")

  console.log(selectedAgentData, "selectedAgentData")

  //Edit Equipment
  // const [branchVendorChange, setBranchVendorChange] = useState(false)
  const [commitCountModal, setCommitCountModal] = useState(false)
  const [eventSameAsModal, setEventSameAsModal] = useState(false)
  const [equipmentHistoryViewModal, setEquipmentHistoryViewModal] =
    useState(false)
  const [editEquipmentData, setEditEquipmentData] = useState("")
  const [quantityValue, setQuantityValue] = useState("")
  const [companyDetails, setCompanyDetails] = useState("")
  const [costValue, setCostValue] = useState("")
  const [updateEquipmentModal, setUpdateEquipmentModal] = useState(false)
  const [equipmentHistoryDetails, setEquipmentHistoryDetails] = useState("")
  const [equipmentData, setEquipmentData] = useState([
    {
      _id: "",
      serviceName: "",
      serviceNameValue: "",
      scheduleTypeName: "",
      scheduleTypeValue: "",
      branchVendorName: "",
      branchVendorValue: "",
      vendorName: "",
      vendorValue: "",
      companyId: "",
      equipmentName: "",
      equipmentId: "",
      quantity: "",
      cost: "",
      index: "",
      totalAmount: "",
      equipmentTypeId: "",
    },
  ])
  console.log(serviceList, "serviceList")
  console.log(equipmentType, "equipmentType")
  const addEquipmentArray = () => {
    setEquipmentData([
      ...equipmentData,
      {
        serviceName: "",
        serviceNameValue: "",
        scheduleTypeName: "",
        scheduleTypeValue: "",
        branchVendorName: "",
        branchVendorValue: "",
        vendorName: "",
        vendorValue: "",
        companyId: "",
        equipmentName: "",
        equipmentId: "",
        quantity: "",
        cost: "",
        index: "",
        totalAmount: "",
        equipmentTypeId: "",
        _id: "",
      },
    ])
    setRenderPage(!renderPage)
    setRemoveEquipment(true)
  }

  const removeEquipmentDetails = async (toRemove) => {
    var equipmentDetail = equipmentData
    if (toRemove != 0) {
      if (toRemove > -1) {
        equipmentDetail.splice(toRemove, 1)
      }
      setEquipmentData(equipmentDetail)
      // setRemoveService(false)
      setRenderPage(!renderPage)
    }
  }

  const totalAmountValue =
    !isEmpty(quantityValue) && !isEmpty(costValue)
      ? quantityValue * costValue
      : 0
  //Equipment on change
  console.log(equipmentData, "equipmentData")
  console.log(totalAmountValue, "totalAmountValue")
  const equipmentChange = async (e, index, name) => {
    var equipmentList = equipmentData

    if (name == "serviceNumber") {
      e = e.target.value
      equipmentList[index][name] = e
      setEquipmentData(equipmentList)
    }
    if (name == "serviceNameValue") {
      equipmentList[index]["serviceNameValue"] = e.value
      equipmentList[index]["serviceName"] = e.label

      setEquipmentData(equipmentList)
    }

    if (name == "scheduleTypeValue") {
      equipmentList[index]["scheduleTypeValue"] = e.value
      equipmentList[index]["scheduleTypeName"] = e.label
      if (e.label == "InHouse") {
        equipmentList[index]["quantity"] = e.quantityCount
        equipmentList[index]["cost"] = e.costCount
        equipmentList[index]["totalAmount"] = e.totalAmountCount
      }
      setScheduleValue(e.value)
      setEquipmentData(equipmentList)
    }

    if (name == "branchVendorValue") {
      equipmentList[index]["branchVendorValue"] = e.value
      equipmentList[index]["branchVendorName"] = e.label
      equipmentList[index]["companyId"] = e.companyId
      setCompanyDetails(e)
      // setBranchVendorChange(true)
      if (e) {
        api
          // .post("get_all_equipment_type", { status: "active" })
          .post("get_all_equipment_master", {
            status: "active",
            companyId: e.companyId,
            branchId: e.value,
            equipmentTypeId: equipmentType._id,
          })
          .then((res) => {
            setEquipmentMasterDetails(res.data.data)
            res.data
          })
      }
      setEquipmentData(equipmentList)
    }
    if (name == "vendorValue") {
      equipmentList[index]["vendorValue"] = e.value
      equipmentList[index]["vendorName"] = e.label
      equipmentList[index]["paymentDetails"] = e.paymentDetails
      equipmentList[index]["cost"] =
        !isEmpty(e.paymentDetails) && e.paymentDetails.length > 0
          ? e.paymentDetails.map((data) => data.costPerSession)
          : 0
      // setCompanyDetails(e)
      // setBranchVendorChange(true)
      setEquipmentData(equipmentList)
    }
    if (name == "equipmentId") {
      equipmentList[index]["equipmentId"] = e.value
      equipmentList[index]["equipmentName"] = e.label
      equipmentList[index]["equipmentTypeId"] = e.equipmentTypeId
      setEquipmentData(equipmentList)
    }
    if (name == "quantity") {
      e = e.target.value
      equipmentList[index][name] = e
      setQuantityValue(e)
      setEquipmentData(equipmentList)
    }
    if (name == "cost") {
      e = e.target.value
      equipmentList[index][name] = e
      setCostValue(e)
      setEquipmentData(equipmentList)
    }
    if (name == "totalAmount") {
      e = e.target.value
      console.log(e, "totalAmount")
      equipmentList[index][name] = e
      setEquipmentData(equipmentList)
    }
    setRenderPage(!renderPage)
  }

  console.log(quantityValue, costValue, "quantityValue")
  //Equipment on change end

  //branch vendor change
  // useEffect(() => {
  //   if (companyDetails) {

  //   }
  // }, [branchVendorChange])

  console.log(companyDetails, "companyDetails")
  console.log(equipmentMasterDetails, "equipmentMasterDetails")

  //Equipment history event date

  const eventDate = moment(equipmentHistoryDetails.eventDate).format(
    "DD-MM-YYYY"
  )
  console.log(eventDate, "eventDate")

  //Schedule type options

  const scheduleTypeOptions = [
    {
      label: "InHouse",
      value: "InHouse",
      quantityCount: 0,
      costCount: 0,
      totalAmountCount: 0,
    },
    {
      label: "Vendor",
      value: "vendor",
      quantityCount: "",
      costCount: "",
    },
  ]
  console.log(scheduleValue, "scheduleValue")

  //start and end Time
  const equipmentHistoryStartTime = moment(equipmentHistoryDetails.startTime, [
    "HH.mm",
  ]).format("hh:mm a")
  const equipmentHistoryEndTime = moment(equipmentHistoryDetails.endTime, [
    "HH.mm",
  ]).format("hh:mm a")

  // Service list dropdown
  const serviceListData =
    !isEmpty(serviceList) &&
    serviceList.map((service) => {
      if (service.count === 1) {
        return {
          _id: service.serviceId,
          count: service.count,
          serviceName: service.serviceName,
        }
      }
    })

  const serviceListDetails = !isEmpty(serviceListData)
    ? serviceListData.filter((data) => data !== undefined)
    : []

  // service count > 1
  const serviceCountDetails =
    !isEmpty(serviceList) &&
    serviceList.map((service) => {
      if (service.count > 1) {
        return {
          _id: service.serviceId,
          count: service.count,
          serviceName: service.serviceName,
        }
      }
    })
  const serviceMultipleData = !isEmpty(serviceCountDetails)
    ? serviceCountDetails.filter((data) => data !== undefined)
    : []

  // const serviceCountValue = !isEmpty(serviceCountDetails)

  console.log(serviceMultipleData, "serviceMultipleData")
  // console.log(serviceMultipleArrayData, "serviceMultipleArrayData")

  const serviceCountData = !isEmpty(serviceCountDetails)
    ? serviceMultipleData.concat(serviceMultipleData)
    : []

  const serviceCountArray =
    !isEmpty(serviceListDetails) && !isEmpty(serviceCountData)
      ? serviceListDetails.concat(serviceCountData)
      : !isEmpty(serviceListDetails) && serviceCountData.length === 0
      ? serviceListDetails
      : serviceListDetails.length === 0 && !isEmpty(serviceCountData)
      ? serviceCountData
      : []

  const multipleServiceArray = serviceMultipleData.map((data) => data.count)

  console.log(serviceCountArray, "serviceCountArray")
  console.log(multipleServiceArray, "multipleServiceArray")
  console.log(serviceCountData, "serviceCountData")
  console.log(serviceCountDetails, "serviceCountDetails")

  const createServiceOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.serviceName

        options.push(obj)
      })
    return options
  }

  const serviceListOptions = createServiceOptions(serviceCountArray)
  console.log(serviceListOptions, "serviceListOptions")

  // Service list dropdown section end
  console.log(collapseData, "collapseData")

  //Equipment Master section

  const equipmentMasterData = !isEmpty(equipmentMasterDetails)
    ? equipmentMasterDetails.map((c) => {
        return {
          label: `${c.serialNumber} - ${c.productVersionName}`,
          value: c._id,
          equipmentTypeName: c.equipmentTypeName,
          equipmentBrandName: c.equipmentBrandName,
          productVersionName: c.productVersionName,
          equipmentTypeId: c.equipmentTypeId,
        }
      })
    : []
  const equipmentMasterListData = !isEmpty(equipmentMasterDetails)
    ? equipmentMasterDetails.map((c) => {
        if (c.equipmentTypeId === equipmentType._id) {
          return {
            label: `${c.serialNumber} - ${c.productVersionName}`,
            value: c._id,
            equipmentTypeName: c.equipmentTypeName,
            equipmentBrandName: c.equipmentBrandName,
            productVersionName: c.productVersionName,
            equipmentTypeId: c.equipmentTypeId,
          }
        }
      })
    : []

  const equipmentMasterListDataDetails =
    !isEmpty(equipmentMasterListData) && equipmentMasterListData
      ? equipmentMasterListData.filter((data) => data !== undefined)
      : []

  console.log(equipmentMasterListDataDetails, "equipmentMasterListDataDetails")

  const createMasterOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element.value
        obj.label = element.label
        obj.equipmentTypeName = element.equipmentTypeName
        obj.equipmentBrandName = element.equipmentBrandName
        obj.productVersionName = element.productVersionName
        obj.equipmentTypeId = element.equipmentTypeId

        options.push(obj)
      })
    return options
  }

  const equipmentMasterOptions = createMasterOptions(equipmentMasterData)

  console.log(equipmentMasterOptions, "equipmentMasterOptions")
  console.log(equipmentMasterData, "equipmentMasterData")
  console.log(equipmentData, "equipmentData")

  // Add equipment Details

  const addEquipmentDetails = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const equipmentDetailsData =
        !isEmpty(equipmentData) && equipmentData.length > 0
          ? equipmentData.map((data) => {
              if (data.scheduleTypeValue !== "InHouse") {
                return {
                  serviceId: data.serviceNameValue,

                  type: data.scheduleTypeValue,

                  vendorId: data.vendorValue,
                  equipmentId: data.equipmentId,
                  equipmentTypeId: data.equipmentTypeId,
                  qty: parseFloat(data.quantity),
                  cost: parseFloat(data.totalAmount),
                }
              } else {
                return {
                  serviceId: data.serviceNameValue,

                  type: data.scheduleTypeValue,

                  branchId: data.branchVendorValue,
                  companyId: data.companyId,
                  equipmentId: data.equipmentId,
                  equipmentTypeId: data.equipmentTypeId,
                  qty: parseFloat(data.quantity),
                  cost: parseFloat(data.totalAmount),
                }
              }
            })
          : []
      const equipmentDetails = {
        leadId: id,
        leadEventId: equipmentHistoryDetails.event_id,
        eventdate: moment(equipmentHistoryDetails.eventDate).format(
          "YYYY-MM-DD"
        ),
        equipmentDetails: equipmentDetailsData.filter(
          (data) => data !== undefined
        ),
      }
      dispatch(equipmentAction.addEquipmentDetails(equipmentDetails))
      setTimeout(() => {
        setHistoryModal(false)
        setCommitCountModal(true)
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })

        api
          // .post("get_all_equipment_type", { status: "active" })
          .post("get_all_equipment_type", { status: "active", forEC: true })
          .then((res) => {
            setEquipmentArrayDetails(res.data.data)
            res.data
          })
          .catch((error) => Promise.reject(error))
      }, 1200)
    } else {
      simpleValidator.current.showMessages()
      setHistoryModal(true)
      forceUpdate(1)
    }
  }

  console.log(editEquipmentData, "editEquipmentData")
  console.log(equipmentType, "equipmentType")

  //Update Equipment Details
  const updateEquipmentDetails = () => {
    // con
    const equipmentDetailsData =
      !isEmpty(equipmentData) && equipmentData.length > 0
        ? equipmentData.map((data) => {
            if (data.scheduleTypeValue !== "InHouse") {
              return {
                serviceId: data.serviceNameValue,

                type: data.scheduleTypeValue,

                vendorId: data.vendorValue,

                equipmentId: data.equipmentId,
                equipmentTypeId: data.equipmentTypeId,
                qty: parseFloat(data.quantity),
                cost: parseFloat(data.totalAmount),
                _id: data._id,
              }
            } else {
              return {
                serviceId: data.serviceNameValue,

                type: data.scheduleTypeValue,

                branchId: data.branchVendorValue,
                companyId: data.companyId,

                equipmentId: data.equipmentId,
                equipmentTypeId: data.equipmentTypeId,
                qty: parseFloat(data.quantity),
                cost: parseFloat(data.totalAmount),
                _id: data._id,
              }
            }
          })
        : []
    const equipmentDetails = {
      _id: equipmentHistoryDetails.equipmentscheduling_id,
      leadId: id,
      leadEventId: equipmentHistoryDetails.event_id,
      eventdate: moment(equipmentHistoryDetails.eventDate).format("YYYY-MM-DD"),
      equipmentDetails: equipmentDetailsData.filter(
        (data) => data !== undefined
      ),
    }
    dispatch(equipmentAction.updateEquipmentDetails(equipmentDetails))
    console.log(equipmentDetails, "equipmentDetails")
    setTimeout(() => {
      toast.success("Records Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setHistoryModal(false)
      setCommitCountModal(true)
      api
        // .post("get_all_equipment_type", { status: "active" })
        .post("get_all_equipment_type", { status: "active", forEC: true })
        .then((res) => {
          setEquipmentArrayDetails(res.data.data)
          res.data
        })
        .catch((error) => Promise.reject(error))
      dispatch(equipmentAction.loadEquipmentScheduling(record))
    }, 1200)
  }

  //Equipment schedule details fetching
  useEffect(() => {
    if (historyModal === true) {
      const equipmentSchedule =
        !isEmpty(equipmentArrayList) && equipmentArrayList.length > 0
          ? equipmentArrayList.map((data, index) => {
              if (equipmentType._id === data.equipmentTypeId) {
                return {
                  serviceName: data.serviceName,
                  serviceNameValue: data.serviceId,
                  scheduleTypeName: data.type,
                  scheduleTypeValue: data.type,
                  // branchVendorName: `${data.equipmentIdDetails.supplierName} - ${data.branchName}`,
                  branchVendorName: data.branchName,
                  branchVendorValue: data.branchId,
                  companyId: data.companyId,
                  equipmentName: !isEmpty(data.equipmentIdDetails)
                    ? `${data.equipmentIdDetails.serialNumber} - ${data.equipmentIdDetails.productVersionName}`
                    : "",
                  equipmentId: data.equipmentId,
                  quantity: data.qty,
                  cost: data.cost,
                  totalAmount: data.total,
                  equipmentTypeId: data.equipmentTypeId,
                  _id: data._id,
                  index: index,
                }
              }
            })
          : []
      const equipmentScheduleDetailsData = !isEmpty(equipmentSchedule)
        ? equipmentSchedule.filter((data) => data !== undefined)
        : []
      const equipmentScheduleData = !isEmpty(equipmentScheduleDetailsData)
        ? equipmentScheduleDetailsData
        : equipmentData
      setEquipmentData(equipmentScheduleData)
      setEditEquipmentData(equipmentScheduleData)
      api
        // .post("get_all_equipment_type", { status: "active" })
        .post("get_all_equipment_master", { status: "active" })
        .then((res) => {
          setEquipmentMasterDetails(res.data.data)
          res.data
        })
      console.log(equipmentScheduleData, "equipmentSchedule")
    }
  }, [historyModal])

  console.log(equipmentMasterDetails, "equipmentMasterDetails")

  useEffect(() => {
    if (commitCountModal === true) {
      api
        // .post("get_all_equipment_type", { status: "active" })
        .post("get_Equipment_Sheduleing", { leadId: id })
        .then((res) => {
          // setCommitDetailsArray(res.data.data)
          setTimeout(() => {
            const collapseDataDetails =
              !isEmpty(res.data.data) && res.data.data
                ? res.data.data.map((data) => {
                    if (data.eventId === collapseDetails.eventId) return data
                  })
                : []
            const collapseDetailsList = !isEmpty(collapseDataDetails)
              ? collapseDataDetails.filter((data) => data !== undefined)
              : []

            console.log(collapseDataDetails, "collapseDataDetails")
            console.log(collapseDetailsList, "collapseDetailsList")
            setCollapseDetails(collapseDetailsList[0])
            // setCollapseDetails(collapseData.equipmentScheduleDetails)
          }, 2000)
          res.data
        })
    }
  }, [commitCountModal])

  console.log(equipmentArrayList, "equipmentArrayList")

  //Equipment Vacancy section

  const [equipmentVacancyModal, setEquipmentVacancyModal] = useState(false)
  const [equipmentEventDate, setEquipmentEventDate] = useState("")
  //EVent dates
  const collapseEquipmentEventDate = moment(collapseDetails.eventDate).format(
    "YYYY-MM-DD"
  )
  const eventMonth = moment(collapseDetails.eventDate).format("MM")
  const eventYear = moment(collapseDetails.eventDate).format("YYYY")

  console.log(eventMonth, eventYear, "event month and year")

  useEffect(() => {
    if (equipmentVacancyModal === true) {
      dispatch(
        equipmentAction.loadEquipmentVacancy({
          month: eventMonth,
          year: eventYear,
          equipmentTypeId: equipmentType._id,
        })
      )
      dispatch(
        equipmentAction.loadEquipmentOfficeVacancy({
          month: eventMonth,
          year: eventYear,
          equipmentTypeId: equipmentType._id,
        })
      )
      api
        // .post("get_all_equipment_type", { status: "active" })
        .post("get_all_equipment_master", { status: "active" })
        .then((res) => {
          setEquipmentSearchDetails(res.data.data)
          res.data
        })
        .catch((error) => Promise.reject(error))
    }
    setEquipmentEventDate(collapseEquipmentEventDate)
  }, [equipmentVacancyModal])

  const [equipmentVacancy, setEquipmentVacancy] = useState([])
  const [officeDetails, setOfficeDetails] = useState("")
  const [vacancyId, setVacancyId] = useState("")
  const [vacancyEquipmentDetails, setVacancyEquipmentDetails] = useState("")
  const employeeList =
    !isEmpty(equipmentSearchDetails) &&
    equipmentSearchDetails.map((equipment) => {
      return {
        _id: equipment._id,
        serialNumber: equipment.serialNumber,
        equipmentTypeName: equipment.equipmentTypeName,
        equipmentTypeId: equipment.equipmentTypeId,
        equipmentBrandName: equipment.equipmentBrandName,
        equipmentBrandId: equipment.equipmentBrandId,
      }
    })
  console.log(vacancyId, "vacancyId")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        // const labelEmployee = element.serialNumber.concat(
        //   " - ",
        //   element.equipmentTypeName
        // )
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.equipmentTypeName = element.equipmentTypeName
        obj.label = element.serialNumber
        obj.equipmentTypeId = element.equipmentTypeId
        obj.equipmentBrandName = element.equipmentBrandName
        obj.equipmentBrandId = element.equipmentBrandId
        options.push(obj)
      })
    return options
  }

  const equipmentOptions = createOptions(employeeList)
  console.log(equipmentOptions, "equipmentOptions")

  const fuseOptions = {
    keys: ["serialNumber", "label"],
  }

  const currentMonth = moment().format("MMMM")
  console.log(currentMonth, "currentMonth")
  // console.log(agent_vacancy_details, "agent_vacancy_details")
  const month = moment().format("MM")
  const year = moment().format("YYYY")
  console.log(month, "month")

  const handleEquipmentModalClose = () => setEquipmentVacancyModal(false)
  const equipmentVacantMonth = moment(equipmentEventDate).format("MM")
  const equipmentVacantMonthName = moment(equipmentEventDate).format("MMMM")
  const equipmentVacantYear = moment(equipmentEventDate).format("YYYY")
  //Agent vacancy search
  const equipmentVacancySearch = () => {
    let record = {
      equipmentId: equipmentVacancy.value,
      // departmentId: equipmentVacancy.departmentId,
      month: !isEmpty(equipmentVacantMonth) ? equipmentVacantMonth : eventMonth,
      year: !isEmpty(equipmentVacantYear) ? equipmentVacantYear : eventMonth,
    }
    let recordSearch = {
      equipmentId: equipmentVacancy.value,
      // departmentId: [equipmentVacancy.departmentId],
      month: !isEmpty(equipmentVacantMonth) ? equipmentVacantMonth : eventMonth,
      year: !isEmpty(equipmentVacantYear) ? equipmentVacantYear : eventMonth,
    }

    console.log(record, "agent record")
    console.log(recordSearch, "agent recordSearch")

    dispatch(equipmentAction.loadEquipmentVacancy(record))
    dispatch(equipmentAction.loadEquipmentOfficeVacancy(recordSearch))
  }

  const officeEditDetails = (data) => {
    setOfficeDetails(data)
    console.log(data, "data from edit")
    // setServiceDetailsData([
    //   {

    //   }
    // ])
    setEquipmentVacancyModal(false)
  }

  console.log(officeDetails, "officeDetails")
  console.log(equipmentEventDate, "equipmentEventDate")
  //Employee Name from agent vacancy details

  const agentDetailsName =
    !isEmpty(equipment_vacancy_details) && equipment_vacancy_details.length > 0
      ? equipment_vacancy_details.find(
          (data) => data.equipmentMasterId === officeDetails.equipmentMasterId
        )
      : []

  console.log(agentDetailsName, "agentDetailsName")
  console.log(vacancyEquipmentDetails, "vacancyEquipmentDetails")

  console.log(vacancyIndex, "vacancyIndex")
  //Office selection
  useEffect(() => {
    if (equipmentVacancyModal === false && !isEmpty(officeDetails)) {
      const equipmentServiceDetails =
        !isEmpty(vacancyEquipmentDetails) && vacancyEquipmentDetails.length > 0
          ? vacancyEquipmentDetails.map((data) => {
              console.log(data, "data from agent vacancy")
              if (data.index == vacancyIndex) {
                return {
                  serviceName: data.serviceName,
                  serviceNameValue: data.serviceNameValue,
                  scheduleTypeName: data.scheduleTypeName,
                  scheduleTypeValue: data.scheduleTypeValue,
                  // branchVendorName: `${data.equipmentIdDetails.supplierName} - ${data.branchName}`,
                  branchVendorName: data.branchVendorName,
                  branchVendorValue: data.branchVendorValue,
                  companyId: data.companyId,
                  equipmentName: `${agentDetailsName.serialNumber} - ${agentDetailsName.productVersionName}`,
                  equipmentId: officeDetails.equipmentMasterId,
                  quantity: data.quantity,
                  index: data.index,
                  cost: data.cost,
                  totalAmount: data.totalAmount,
                  equipmentTypeId: data.equipmentTypeId,
                  _id: data._id,
                }
              }
            })
          : []

      //VacancyId not Equal selection
      const equipmentVacancyDetails =
        !isEmpty(vacancyEquipmentDetails) && vacancyEquipmentDetails.length > 0
          ? vacancyEquipmentDetails.map((data) => {
              if (data.index != vacancyIndex) {
                return {
                  serviceName: data.serviceName,
                  serviceNameValue: data.serviceNameValue,
                  scheduleTypeName: data.scheduleTypeName,
                  scheduleTypeValue: data.scheduleTypeValue,
                  // branchVendorName: `${data.equipmentIdDetails.supplierName} - ${data.branchName}`,
                  branchVendorName: data.branchVendorName,
                  branchVendorValue: data.branchVendorValue,
                  companyId: data.companyId,
                  equipmentName: data.equipmentName,
                  equipmentId: data.equipmentId,
                  quantity: data.quantity,
                  cost: data.cost,
                  index: data.index,
                  totalAmount: data.totalAmount,
                  equipmentTypeId: data.equipmentTypeId,
                  _id: data._id,
                }
              }
            })
          : []

      const equipmentVacancyServiceDetails =
        !isEmpty(equipmentVacancyDetails) && equipmentVacancyDetails.length > 0
          ? equipmentVacancyDetails.filter((data) => data !== undefined)
          : []
      const equipmentServiceVacancyDetails =
        !isEmpty(equipmentServiceDetails) && equipmentServiceDetails.length > 0
          ? equipmentServiceDetails.filter((data) => data !== undefined)
          : []

      //Two arrays concatination
      const officeSelectionServiceDetails =
        equipmentServiceVacancyDetails &&
        equipmentServiceVacancyDetails.length > 0 &&
        equipmentVacancyServiceDetails &&
        equipmentVacancyServiceDetails.length > 0
          ? equipmentServiceVacancyDetails.concat(
              equipmentVacancyServiceDetails
            )
          : equipmentVacancyServiceDetails &&
            equipmentVacancyServiceDetails.length === 0
          ? equipmentServiceVacancyDetails
          : equipmentServiceVacancyDetails &&
            equipmentServiceVacancyDetails.length > 0
          ? equipmentVacancyServiceDetails
          : []
      const sortAndMap = (arr = []) => {
        const copy = arr.slice()
        const sorter = (a, b) => {
          return a["index"] - b["index"]
        }
        copy.sort(sorter)

        return copy
      }
      const officeDetailsSelected = sortAndMap(officeSelectionServiceDetails)
      setEquipmentData(officeDetailsSelected)

      console.log(officeDetailsSelected, "officeDetailsSelected")
      // setTimeout(() => {

      // }, 1000)
      console.log(equipmentVacancyDetails, "equipmentVacancyDetails")
      console.log(equipmentServiceDetails, "equipmentServiceDetails")
      console.log(
        equipmentVacancyServiceDetails,
        "equipmentVacancyServiceDetails"
      )
      console.log(
        officeSelectionServiceDetails,
        "officeSelectionServiceDetails"
      )
      console.log(equipmentData, "equipmentData")
      console.log(
        equipmentServiceVacancyDetails,
        "equipmentServiceVacancyDetails"
      )
    }
    // else if (isEmpty(officeDetails)) {
    //   setEquipmentData(equipmentData)
    // }
    else if (removeEquipment === true && equipmentVacancyModal === false) {
      setEquipmentData(equipmentData)
    }
  }, [equipmentVacancyModal])

  const finalCommit = () => {
    var equipmentCommit = {
      leadId: id,
      eventId: [eventId],
    }
    console.log(equipmentCommit, "equipmentCommit")
    dispatch(equipmentAction.equipmentFinalCommit(equipmentCommit))
    setTimeout(() => {
      dispatch(equipmentAction.loadEquipmentScheduling({ leadId: id }))

      toast.success("Records Committed Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      setFinalCommitModal(false)
    }, 1500)
  }

  return (
    <React.Fragment>
      <Container>
        <Row className="quote-head-content">
          <Col md="12" lg="12" sm="12" className="d-flex flex-row">
            <p className="quote-head">
              Equipment Scheduling
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="quoteInfo1"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="quoteInfo1">
                  Equipment Scheduling
                </UncontrolledTooltip>
              </span>
            </p>
            <div style={{ width: "150px", marginRight: "10px" }}>
              <MultiSelect
                value={tableFilterOptions}
                onChange={setTableFilterOptions}
                options={finalCommitOptions}
                labelledBy="Select Event"
                hasSelectAll={true}
                disabled={modeMenu === "EventComplete" ? true : false}
              />
              {/* {simpleValidator.current.message(
                "tableFilterOpt",
                 tableFilterOpt,
                 "required"
              )} */}
              {finalCommitValidation && tableFilterOptions.length == 0 ? (
                <span
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  Final Commit field is required
                </span>
              ) : (
                ""
              )}
            </div>
            <div>
              <Button
                type="submit"
                className="btn btn-danger"
                disabled={modeMenu === "EventComplete" ? true : false}
                onClick={() => {
                  if (tableFilterOptions.length > 0) {
                    setEventFinalCommitModal(true)
                  } else {
                    setFinalCommitValidation(true)
                  }
                }}
              >
                Final Commit
              </Button>
            </div>
          </Col>
        </Row>
        <div className="mb-3">
          {!isEmpty(collapseData) && collapseData.length > 0 ? (
            collapseData.map((data) => {
              return (
                <Row
                  className="question-card-content mb-1"
                  style={{ padding: "0px 4px" }}
                  key={data.eventId}
                >
                  <Col>
                    <div className="d-flex flex-row ">
                      <p
                        style={{
                          fontSize: "15px",
                          marginBottom: "12px",
                          marginRight: "8px",
                          // padding: "0px 8px",
                          fontWeight: 550,
                          marginTop: "10px",
                        }}
                      >
                        {data.eventNo}
                      </p>
                      {!isEmpty(data) && data.isCommitted === true ? (
                        <div
                          style={{
                            marginTop: "12px",
                            // marginLeft: "8px"
                          }}
                        >
                          {" "}
                          <button
                            style={{
                              background: "#34c38f",
                              border: "none",
                              // cursor: "pointer",
                              fontSize: "12px",
                              color: "white",
                              padding: "2px 2px",
                              borderRadius: "4px",
                            }}
                          >
                            {"Committed"}
                          </button>
                        </div>
                      ) : (
                        <div
                          style={{
                            marginTop: "12px",
                            // marginLeft: "8px"
                          }}
                        >
                          <button
                            style={{
                              background: "#f34848",
                              border: "none",
                              // cursor: "pointer",
                              fontSize: "12px",
                              color: "white",
                              padding: "2px 2px",
                              borderRadius: "4px",
                            }}
                          >
                            {"Not Committed"}
                          </button>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col>
                    {/* {modeMenu === "EventComplete" ? "":  */}
                    <div
                      style={{
                        color: "#291213",
                        height: "22px",
                        width: "max-content",
                        textAlign: "center",
                        cursor: "pointer",
                        fontSize: "24px",
                        marginTop: "10px",
                        float: "right",
                        display: "flex",
                      }}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                      onClick={() => {
                        if (data.eventId) {
                          setCollapseDetails(data)
                          setOpen(!open)
                        }
                      }}
                    >
                      <i className="fas fa-angle-down"></i>
                    </div>
                    {/* } */}
                  </Col>
                  <Collapse
                    in={data.eventId === collapseDetails.eventId && open}
                    // in={open}
                  >
                    <div id="example-collapse-text">
                      <Row>
                        <Col md="2" lg="2" sm="2" className="mt-3">
                          <Card
                            style={{
                              border: "2px solid rgb(239, 242, 247)",
                              textAlign: "center",
                              boxShadow:
                                "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
                            }}
                          >
                            <CardBody>
                              <Col sm="12" md="12" lg="12">
                                <div
                                  style={{
                                    fontSize: "22px",
                                    fontWeight: "bold",
                                    flex: "display",
                                  }}
                                >
                                  {" "}
                                  EVENT
                                </div>
                              </Col>

                              <h1
                                style={{
                                  color: "#E40D8C",
                                  textAlign: "center",
                                }}
                              >
                                {!isEmpty(collapseDetails)
                                  ? collapseDetails.eventNo.split("Event")
                                  : ""}
                              </h1>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md="10" lg="10" sm="10">
                          <Row className="mt-3">
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                {"Event Name :"}
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.eventName)
                                  ? collapseDetails.eventName
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                {"Date :"}
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.eventDate)
                                  ? moment(collapseDetails.eventDate).format(
                                      "DD-MM-YYYY"
                                    )
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                {"Start Time :"}
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.startTime)
                                  ? eventStartTimeData
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                End Time:
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.endTime)
                                  ? eventEndTimeData
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                Venue Name :
                              </p>
                              <p
                                style={{
                                  fontWeight: "550",
                                  // width: "max-content",
                                }}
                              >
                                {!isEmpty(collapseDetails.venueName)
                                  ? collapseDetails.venueName
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                Venue Location:
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.venueLocation)
                                  ? collapseDetails.venueLocation
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                Food :
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.food)
                                  ? collapseDetails.food
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                Travel :
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.travel)
                                  ? collapseDetails.travel
                                  : "--"}
                              </p>
                            </Col>

                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                Crew Assembly :
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.crewAssemblyTime)
                                  ? crewAssemblyTimeData
                                  : "--"}
                              </p>
                            </Col>
                            <Col md="3" lg="3" sm="3">
                              <p
                                style={{
                                  fontWeight: "450",
                                  marginBottom: "-1px",
                                }}
                              >
                                Crowd Strength :
                              </p>
                              <p style={{ fontWeight: "550" }}>
                                {!isEmpty(collapseDetails.crowdStrength)
                                  ? collapseDetails.crowdStrength
                                  : "--"}
                              </p>
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row
                            // className="question-card-content"
                            style={{ marginTop: "30px" }}
                            // className="d-flex flex-row justify-content-end"
                          >
                            <Col sm="12" md="12" lg="12">
                              <div className="d-flex flex-row justify-content-between">
                                <div>
                                  <Button
                                    type="submit"
                                    className={
                                      modeMenu === "EventComplete"
                                        ? "btn btn-danger disabled-button"
                                        : data.isCommitted == true
                                        ? "btn btn-success"
                                        : "btn btn-danger"
                                    }
                                    onClick={() => {
                                      setEventId(data.event_id)
                                      setFinalCommitModal(true)
                                    }}
                                    style={{ marginRight: "8px" }}
                                  >
                                    {data.isCommitted == true
                                      ? "Committed"
                                      : "Final Commit"}
                                  </Button>
                                </div>
                                <div
                                  style={{ marginTop: "-21px", width: "150px" }}
                                >
                                  <Label
                                    className={"form-label"}
                                    style={{ marginBottom: "-4px" }}
                                  >
                                    Same As
                                  </Label>
                                  <MultiSelect
                                    value={tableFilterOpt}
                                    name="tableFilterOpt"
                                    className={
                                      modeMenu === "EventComplete"
                                        ? "disabled-button"
                                        : ""
                                    }
                                    // onChange={(e) => eventOnChange(e, data.eventId)}
                                    onChange={(e) => {
                                      setTableFilterOpt(e)
                                      setEventSameModal(true)
                                    }}
                                    // ClearSelectedIcon={setTableFilterOpt([])}
                                    options={eventSameOptions}
                                    labelledBy="Select Event"
                                    hasSelectAll={true}
                                  />
                                </div>
                              </div>
                            </Col>

                            {/* <span>Event</span>{" "}
                                <i className="fas fa-angle-down mx-3 font-size-18"></i> */}
                          </Row>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col lg="4" md="4" xs="4" sm="4">
                          <Card
                            style={{
                              boxShadow:
                                "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
                            }}
                          >
                            <CardHeader
                              style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                minHeight: "40px",
                                fontSize: "16px",
                              }}
                            >
                              Service List
                            </CardHeader>
                            <CardBody>
                              {!isEmpty(collapseDetails) &&
                              collapseDetails.serviceDetails.length > 0
                                ? collapseDetails.serviceDetails.map(
                                    (service) => {
                                      return (
                                        <Row key={service._id}>
                                          <Col
                                            xl="12"
                                            lg="12"
                                            md="12"
                                            sm="12"
                                            className="d-flex flex-row justify-content-between"
                                          >
                                            <div className="d-flex flex-row service-main-header">
                                              <p className="service-equipment-name">
                                                {`${service.serviceName} -
                                                ${service.count}`}
                                              </p>
                                              <p className="ec-service-count-list">
                                                (
                                                {`${service.office} -
                                                  OF`}
                                                {"/"}
                                                {`${service.freelancer} -
                                                  FL`}
                                                )
                                              </p>
                                            </div>
                                            <div>
                                              <span
                                              // className={
                                              //   modeMenu === "EventComplete"
                                              //     ? "disabled-button"
                                              //     : ""
                                              // }
                                              >
                                                <i
                                                  className="fas fa-eye icon-btn ec-equipment-service-icon"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {
                                                    setServiceHistoryDetails(
                                                      service.history
                                                    )
                                                    setServiceHistoryModal(true)
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </Col>
                                        </Row>
                                      )
                                    }
                                  )
                                : ""}
                            </CardBody>
                          </Card>
                        </Col>
                        {/* Equipment Details Section */}
                        <Col
                          lg="8"
                          md="8"
                          xl="8"
                          xs="12"
                          sm="12"
                          style={{
                            boxShadow:
                              "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
                            marginBottom: "23px",
                            padding: "4px 17px",
                          }}
                          // className="d-flex flex-row"
                        >
                          <Row className="mt-2">
                            {!isEmpty(oddEquipmentData) &&
                            oddEquipmentData &&
                            oddEquipmentData.length > 0
                              ? oddEquipmentData.map((equipment) => {
                                  const equipmentTypeFilter =
                                    eventSameAsModal === true &&
                                    !isEmpty(equipmentArrayList) &&
                                    equipmentArrayList.length > 0
                                      ? equipmentArrayList.map((data) => {
                                          if (
                                            data.equipmentTypeId ===
                                            equipment._id
                                          ) {
                                            return data
                                          }
                                        })
                                      : !isEmpty(collapseDetails) &&
                                        collapseDetails.equipmentScheduleDetails &&
                                        collapseDetails.equipmentScheduleDetails
                                          .length > 0
                                      ? collapseDetails.equipmentScheduleDetails.map(
                                          (data) => {
                                            if (
                                              data.equipmentTypeId ===
                                              equipment._id
                                            ) {
                                              return data
                                            }
                                          }
                                        )
                                      : []
                                  const equipmentCount = !isEmpty(
                                    equipmentTypeFilter
                                  )
                                    ? equipmentTypeFilter.filter(
                                        (data) => data !== undefined
                                      )
                                    : []
                                  const equipmentListCount =
                                    !isEmpty(equipmentCount) &&
                                    equipmentCount.length < 10
                                      ? `0${equipmentCount.length}`
                                      : equipmentCount.length > 10
                                      ? equipmentCount.length
                                      : "00"
                                  console.log(equipmentCount, "equipmentCount")
                                  console.log(equipmentListCount, "listCount")
                                  return (
                                    <Col
                                      xl="6"
                                      md="6"
                                      lg="6"
                                      xs="6"
                                      sm="6"
                                      key={equipment._id}
                                      // style={{marginBottom: "-10px"}}
                                    >
                                      <div className="mb-3 d-flex flex-row justify-content-between equipment-name-list">
                                        <div
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {equipment.equipmentType}
                                        </div>
                                        <div>
                                          <span className="equipment-name-list-count">
                                            {equipmentListCount}
                                            {/* {equipmentListCount} */}
                                          </span>
                                          {(collapseDetails.equipmentScheduleDetails &&
                                            collapseDetails
                                              .equipmentScheduleDetails.length >
                                              0 &&
                                            equipmentCount.length > 0) ||
                                          (eventSameAsModal === true &&
                                            equipmentCount.length > 0) ? (
                                            <>
                                              <i
                                                className={
                                                  modeMenu === "EventComplete"
                                                    ? "disabled-button fas fa-edit icon-btn equipment-name-list-eye-icon mx-2"
                                                    : "fas fa-edit icon-btn equipment-name-list-eye-icon mx-2"
                                                }
                                                onClick={() => {
                                                  // editEquipmentDetails(
                                                  //   collapseDetails.equipmentScheduleDetails
                                                  // )
                                                  setHistoryModal(true)
                                                  setEquipmentHistoryDetails(
                                                    data
                                                  )
                                                  setServiceList(
                                                    collapseDetails.serviceDetails
                                                  )
                                                  setUpdateEquipmentModal(true)
                                                  if (
                                                    !isEmpty(
                                                      equipmentArrayList
                                                    ) &&
                                                    equipmentArrayList.length >
                                                      0
                                                  ) {
                                                    setEquipmentArrayList(
                                                      equipmentArrayList
                                                    )
                                                  } else {
                                                    setEquipmentArrayList(
                                                      collapseDetails.equipmentScheduleDetails
                                                    )
                                                  }
                                                  setEquipmentType(equipment)
                                                  setFullscreen(true)
                                                }}
                                              ></i>
                                            </>
                                          ) : (
                                            <>
                                              <i
                                                className={
                                                  modeMenu === "EventComplete"
                                                    ? "disabled-button fas fa-plus icon-btn equipment-name-list-eye-icon mx-1"
                                                    : "fas fa-plus icon-btn equipment-name-list-eye-icon mx-2"
                                                }
                                                onClick={() => {
                                                  setHistoryModal(true)
                                                  setEquipmentHistoryDetails(
                                                    data
                                                  )
                                                  setServiceList(
                                                    collapseDetails.serviceDetails
                                                  )
                                                  // setAddEquipmentHistory(true)
                                                  if (
                                                    equipmentCount.length === 0
                                                  ) {
                                                    setEquipmentData([
                                                      // ...equipmentData,
                                                      {
                                                        serviceName: "",
                                                        serviceNameValue: "",
                                                        scheduleTypeName: "",
                                                        scheduleTypeValue: "",
                                                        branchVendorName: "",
                                                        branchVendorValue: "",
                                                        companyId: "",
                                                        equipmentName: "",
                                                        equipmentId: "",
                                                        quantity: "",
                                                        cost: "",
                                                        totalAmount: "",
                                                        equipmentTypeId: "",
                                                        _id: "",
                                                      },
                                                    ])
                                                  }
                                                  setUpdateEquipmentModal(false)
                                                  setEquipmentType(equipment)
                                                  setFullscreen(true)
                                                }}
                                              ></i>
                                            </>
                                          )}
                                          <i
                                            className={
                                              "fas fa-eye icon-btn equipment-name-list-eye-icon mx-1"
                                            }
                                            onClick={() => {
                                              if (
                                                collapseDetails.equipmentScheduleDetails &&
                                                collapseDetails
                                                  .equipmentScheduleDetails
                                                  .length > 0 &&
                                                equipmentCount.length > 0
                                              ) {
                                                setEquipmentHistoryViewModal(
                                                  true
                                                )
                                                setHistoryModal(true)
                                                setEquipmentHistoryDetails(data)
                                                setServiceList(
                                                  collapseDetails.serviceDetails
                                                )
                                                setUpdateEquipmentModal(true)
                                                if (
                                                  !isEmpty(
                                                    equipmentArrayList
                                                  ) &&
                                                  equipmentArrayList.length > 0
                                                ) {
                                                  setEquipmentArrayList(
                                                    equipmentArrayList
                                                  )
                                                } else {
                                                  setEquipmentArrayList(
                                                    collapseDetails.equipmentScheduleDetails
                                                  )
                                                }
                                                setEquipmentType(equipment)
                                                setFullscreen(true)
                                              } else {
                                                setEquipmentHistoryViewModal(
                                                  true
                                                )
                                                setHistoryModal(true)
                                                setEquipmentHistoryDetails(data)
                                                setServiceList(
                                                  collapseDetails.serviceDetails
                                                )
                                                // setAddEquipmentHistory(true)
                                                if (
                                                  equipmentCount.length === 0
                                                ) {
                                                  setEquipmentData([
                                                    // ...equipmentData,
                                                    {
                                                      serviceName: "",
                                                      serviceNameValue: "",
                                                      scheduleTypeName: "",
                                                      scheduleTypeValue: "",
                                                      branchVendorName: "",
                                                      branchVendorValue: "",
                                                      companyId: "",
                                                      equipmentName: "",
                                                      equipmentId: "",
                                                      quantity: "",
                                                      cost: "",
                                                      totalAmount: "",
                                                      equipmentTypeId: "",
                                                      _id: "",
                                                    },
                                                  ])
                                                }
                                                setUpdateEquipmentModal(false)
                                                setEquipmentType(equipment)
                                                setFullscreen(true)
                                              }
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </Col>
                                  )
                                })
                              : ""}
                            {!isEmpty(evenEquipmentData) &&
                            evenEquipmentData &&
                            evenEquipmentData.length > 0
                              ? evenEquipmentData.map((equipment) => {
                                  const equipmentTypeFilter =
                                    eventSameAsModal === true &&
                                    !isEmpty(equipmentArrayList) &&
                                    equipmentArrayList.length > 0
                                      ? equipmentArrayList.map((data) => {
                                          if (
                                            data.equipmentTypeId ===
                                            equipment._id
                                          ) {
                                            return data
                                          }
                                        })
                                      : !isEmpty(collapseDetails) &&
                                        collapseDetails.equipmentScheduleDetails &&
                                        collapseDetails.equipmentScheduleDetails
                                          .length > 0
                                      ? collapseDetails.equipmentScheduleDetails.map(
                                          (data) => {
                                            if (
                                              data.equipmentTypeId ===
                                              equipment._id
                                            ) {
                                              return data
                                            }
                                          }
                                        )
                                      : []
                                  const equipmentCount = !isEmpty(
                                    equipmentTypeFilter
                                  )
                                    ? equipmentTypeFilter.filter(
                                        (data) => data !== undefined
                                      )
                                    : []
                                  console.log(equipmentCount, "equipmentCount")
                                  const equipmentListCount =
                                    !isEmpty(equipmentCount) &&
                                    equipmentCount.length > 0 &&
                                    equipmentCount.length < 10
                                      ? `0${equipmentCount.length}`
                                      : equipmentCount.length > 10
                                      ? equipmentCount.length
                                      : "00"
                                  return (
                                    <Col
                                      xl="6"
                                      md="6"
                                      lg="6"
                                      xs="6"
                                      sm="6"
                                      // className="mx-2"
                                      key={equipment._id}
                                    >
                                      <div className="mb-3 d-flex flex-row justify-content-between equipment-name-list">
                                        <div
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {equipment.equipmentType}
                                        </div>
                                        <div>
                                          <span className="equipment-name-list-count">
                                            {equipmentListCount}
                                            {/* {equipmentListCount} */}
                                          </span>
                                          {(collapseDetails.equipmentScheduleDetails &&
                                            collapseDetails
                                              .equipmentScheduleDetails.length >
                                              0 &&
                                            equipmentCount.length > 0) ||
                                          (eventSameAsModal === true &&
                                            equipmentCount.length > 0) ? (
                                            <>
                                              <i
                                                className={
                                                  modeMenu === "EventComplete"
                                                    ? "disabled-button fas fa-edit icon-btn equipment-name-list-eye-icon mx-2"
                                                    : "fas fa-edit icon-btn equipment-name-list-eye-icon mx-2"
                                                }
                                                onClick={() => {
                                                  // editEquipmentDetails(
                                                  //   collapseDetails.equipmentScheduleDetails
                                                  // )
                                                  setHistoryModal(true)
                                                  setEquipmentHistoryDetails(
                                                    data
                                                  )
                                                  setServiceList(
                                                    collapseDetails.serviceDetails
                                                  )
                                                  if (
                                                    !isEmpty(
                                                      equipmentArrayList
                                                    ) &&
                                                    equipmentArrayList.length >
                                                      0
                                                  ) {
                                                    setEquipmentArrayList(
                                                      equipmentArrayList
                                                    )
                                                  } else {
                                                    setEquipmentArrayList(
                                                      collapseDetails.equipmentScheduleDetails
                                                    )
                                                  }
                                                  setUpdateEquipmentModal(true)

                                                  setEquipmentType(equipment)
                                                  setFullscreen(true)
                                                }}
                                              ></i>
                                            </>
                                          ) : (
                                            <>
                                              <i
                                                className={
                                                  modeMenu === "EventComplete"
                                                    ? "disabled-button fas fa-plus icon-btn equipment-name-list-eye-icon mx-2"
                                                    : "fas fa-plus icon-btn equipment-name-list-eye-icon mx-2"
                                                }
                                                onClick={() => {
                                                  setHistoryModal(true)
                                                  setEquipmentHistoryDetails(
                                                    data
                                                  )
                                                  setServiceList(
                                                    collapseDetails.serviceDetails
                                                  )
                                                  if (
                                                    equipmentCount.length === 0
                                                  ) {
                                                    setEquipmentData([
                                                      // ...equipmentData,
                                                      {
                                                        serviceName: "",
                                                        serviceNameValue: "",
                                                        scheduleTypeName: "",
                                                        scheduleTypeValue: "",
                                                        branchVendorName: "",
                                                        branchVendorValue: "",
                                                        companyId: "",
                                                        equipmentName: "",
                                                        equipmentId: "",
                                                        quantity: "",
                                                        cost: "",
                                                        totalAmount: "",
                                                        equipmentTypeId: "",
                                                        _id: "",
                                                      },
                                                    ])
                                                  }
                                                  setUpdateEquipmentModal(false)
                                                  // setAddEquipmentHistory(true)
                                                  setEquipmentType(equipment)
                                                  setFullscreen(true)
                                                }}
                                              ></i>
                                            </>
                                          )}
                                          <i
                                            className={
                                              "fas fa-eye icon-btn equipment-name-list-eye-icon mx-1"
                                            }
                                            onClick={() => {
                                              if (
                                                collapseDetails.equipmentScheduleDetails &&
                                                collapseDetails
                                                  .equipmentScheduleDetails
                                                  .length > 0 &&
                                                equipmentCount.length > 0
                                              ) {
                                                setEquipmentHistoryViewModal(
                                                  true
                                                )
                                                setHistoryModal(true)
                                                setEquipmentHistoryDetails(data)
                                                setServiceList(
                                                  collapseDetails.serviceDetails
                                                )
                                                setUpdateEquipmentModal(true)
                                                if (
                                                  !isEmpty(
                                                    equipmentArrayList
                                                  ) &&
                                                  equipmentArrayList.length > 0
                                                ) {
                                                  setEquipmentArrayList(
                                                    equipmentArrayList
                                                  )
                                                } else {
                                                  setEquipmentArrayList(
                                                    collapseDetails.equipmentScheduleDetails
                                                  )
                                                }
                                                setEquipmentType(equipment)
                                                setFullscreen(true)
                                              } else {
                                                setEquipmentHistoryViewModal(
                                                  true
                                                )
                                                setHistoryModal(true)
                                                setEquipmentHistoryDetails(data)
                                                setServiceList(
                                                  collapseDetails.serviceDetails
                                                )
                                                // setAddEquipmentHistory(true)
                                                if (
                                                  equipmentCount.length === 0
                                                ) {
                                                  setEquipmentData([
                                                    // ...equipmentData,
                                                    {
                                                      serviceName: "",
                                                      serviceNameValue: "",
                                                      scheduleTypeName: "",
                                                      scheduleTypeValue: "",
                                                      branchVendorName: "",
                                                      branchVendorValue: "",
                                                      companyId: "",
                                                      equipmentName: "",
                                                      equipmentId: "",
                                                      quantity: "",
                                                      cost: "",
                                                      totalAmount: "",
                                                      equipmentTypeId: "",
                                                      _id: "",
                                                    },
                                                  ])
                                                }
                                                setUpdateEquipmentModal(false)
                                                setEquipmentType(equipment)
                                                setFullscreen(true)
                                              }
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </Col>
                                  )
                                })
                              : ""}
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </Row>
              )
            })
          ) : (
            <Row className="question-card-content mb-3" key={0}>
              <Col>
                <p
                  style={{
                    fontSize: "15px",
                    marginBottom: "-12px",
                    fontWeight: 550,
                    marginTop: "-1px",
                  }}
                >
                  {"No Events"}
                </p>
              </Col>
              <Col>
                <div
                  style={{
                    color: "#291213",
                    height: "22px",
                    width: "max-content",
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: "24px",
                    float: "right",
                    display: "flex",
                  }}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  onClick={() => {
                    setOpen(!open)
                  }}
                >
                  <i className="fas fa-angle-down"></i>
                </div>
              </Col>
            </Row>
          )}
        </div>

        {/* Service HistoryModal */}
        {serviceHistoryModal && (
          <Modal
            show={serviceHistoryModal}
            onHide={handleServiceHistoryClose}
            size="lg"
            // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Service History
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col sm="12" md="12" lg="12">
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Type</th>
                        <th>Shooter Name</th>
                        <th>Position</th>
                        <th>Service No</th>
                        <th>Service Name</th>
                        <th>Service Cost</th>
                        <th>Payment Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(serviceHistoryDetails) &&
                      serviceHistoryDetails.length > 0 ? (
                        serviceHistoryDetails.map((service, index) => {
                          return (
                            <tr key={service._id}>
                              <th>{index + 1}</th>
                              <td>{service.type}</td>
                              <td>{service.shooterName}</td>
                              <td>{service.position}</td>
                              <td>{service.serviceNo}</td>
                              <td>{service.serviceName}</td>
                              <td>
                                {service.type === "InHouse"
                                  ? 0
                                  : service.serviceCost}
                              </td>
                              <td>{service.paymentStatus}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr key={0}>
                          <td colSpan={10} style={{ textAlign: "center" }}>
                            No records found..
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => handleServiceHistoryClose()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {/* View Equipment Details */}
        {historyModal && (
          <Modal
            show={historyModal}
            onHide={handleHistoryModal}
            fullscreen={fullscreen}
          >
            <Modal.Header className="equipment-service-modal-header">
              <Col xl="12" md="12" lg="12" sm="12" xs="12">
                <div className="sales-modal-header">
                  <h4
                    className="modal-title mt-0 sales-modal-title"
                    id="myModalLabel"
                  >
                    {"View Equipment Details"}
                  </h4>
                  <span>
                    <i
                      className="fa fa-times quote-close"
                      aria-hidden="true"
                      onClick={() => setHistoryModal(false)}
                    ></i>
                  </span>
                </div>
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                      }}
                    >
                      Event Name: :
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {equipmentHistoryDetails.eventName}
                    </p>
                  </div>
                </Col>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                      }}
                    >
                      Date:
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {moment(equipmentHistoryDetails.eventDate).format(
                        "DD-MM-YYYY"
                      )}
                    </p>
                  </div>
                </Col>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                        marginLeft: "5px",
                      }}
                    >
                      Venue Location:
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {equipmentHistoryDetails.venueLcoation}
                    </p>
                  </div>
                </Col>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                      }}
                    >
                      Venue Name:
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {equipmentHistoryDetails.venueName}
                    </p>
                  </div>
                </Col>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                      }}
                    >
                      Start Time:
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {!isEmpty(equipmentHistoryDetails.startTime)
                        ? equipmentHistoryStartTime
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                      }}
                    >
                      End Time:
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {!isEmpty(equipmentHistoryDetails.endTime)
                        ? equipmentHistoryEndTime
                        : "--"}
                    </p>
                  </div>
                </Col>
                <Col md="4" lg="4" sm="4">
                  <div className="d-flex flex-row">
                    {" "}
                    <p
                      style={{
                        fontWeight: "450",
                        marginBottom: "-1px",
                      }}
                    >
                      Crowd Strength:
                    </p>
                    <p style={{ fontWeight: "550", marginLeft: "5px" }}>
                      {equipmentHistoryDetails.crowdStrength}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: "20px" }}>
                <Col xl="12" lg="12" md="12" sm="12">
                  <div
                    style={{
                      fontSize: "16px",
                      color: "#50a5f1",
                      fontWeight: 600,
                      marginTop: "5px",
                    }}
                  >
                    Equipment Type :{" "}
                    <span className="mx-2">{equipmentType.equipmentType}</span>
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                {/* <Col xl="6" lg="6" md="6" sm="6">
                  <div>
                    <Button
                      className="btn btn-info"
                      onClick={() => editEquipmentDetails()}
                      disabled={editEquipmentData.length > 0 ? false : true}
                    >
                      {" "}
                      Edit Equipment
                    </Button>
                  </div>
                </Col> */}
                <Col xl="12" lg="12" md="12" sm="12">
                  <div style={{ float: "right" }} className="d-flex flex-row">
                    <Button
                      className="btn btn-warning"
                      style={{ marginRight: "6px" }}
                      disabled={
                        equipmentHistoryViewModal == true ? true : false
                      }
                      onClick={() => {
                        setEquipmentVacancyModal(true)
                        setFullscreen(true)
                      }}
                    >
                      Equipment Vacancy
                    </Button>
                    <Button
                      className="btn btn-info"
                      onClick={() => addEquipmentArray()}
                      disabled={
                        equipmentHistoryViewModal == true ? true : false
                      }
                    >
                      {" "}
                      Add Equipment
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: "20px" }}>
                <Col xl="12" lg="12" md="12" sm="12">
                  <Table bordered striped>
                    <thead>
                      <tr style={{ fontSize: "10px" }}>
                        <th style={{ width: "20%" }}>Schedule Type</th>
                        <th style={{ width: "15%" }}>Branch Vendor</th>
                        <th style={{ width: "15%" }}>Service</th>
                        <th style={{ width: "20%" }}>Equipment</th>
                        <th style={{ width: "10%" }}>quantity</th>
                        <th style={{ width: "10%" }}>Cost</th>
                        <th style={{ width: "10%" }}>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(equipmentData) ? (
                        equipmentData.map((equipment, index) => {
                          //   const equipmentMasterList = !isEmpty(equipmentMasterOptions) ? equipmentMasterOptions.filter(data=> data.companyId === equipment.branchVendorValue) : []
                          //  console.log(equipmentMasterList, "equipmentMasterList")

                          return (
                            <tr key={index}>
                              <td>
                                <Select
                                  // type="text"
                                  name="scheduleTypeValue"
                                  value={
                                    equipment.scheduleTypeValue
                                      ? {
                                          value: equipment.scheduleTypeValue,
                                          label: equipment.scheduleTypeName,
                                        }
                                      : ""
                                  }
                                  options={scheduleTypeOptions}
                                  onChange={(e) =>
                                    equipmentChange(
                                      e,
                                      index,
                                      "scheduleTypeValue"
                                    )
                                  }
                                  isDisabled={
                                    equipmentHistoryViewModal == true
                                      ? true
                                      : false
                                  }
                                  placeholder="Select Schedule Type"
                                  classNamePrefix="select2-selection"
                                />
                                {simpleValidator.current.message(
                                  "scheduleTypeValue",
                                  equipment.scheduleTypeValue,
                                  "required"
                                )}
                              </td>
                              <td>
                                {equipment.scheduleTypeValue === "vendor" ? (
                                  <>
                                    <Select
                                      // type="text"
                                      name="vendorValue"
                                      value={
                                        equipment.vendorValue
                                          ? {
                                              value: equipment.vendorValue,
                                              label: equipment.vendorName,
                                            }
                                          : ""
                                      }
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.vendorOptions
                                          : []
                                      }
                                      onChange={(e) =>
                                        equipmentChange(e, index, "vendorValue")
                                      }
                                      isDisabled={
                                        equipmentHistoryViewModal == true
                                          ? true
                                          : false
                                      }
                                      placeholder="Select Vendor"
                                      classNamePrefix="select2-selection"
                                    />
                                    {simpleValidator.current.message(
                                      "vendorValue",
                                      equipment.vendorValue,
                                      "required"
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <Select
                                      // type="text"
                                      name="branchVendorValue"
                                      value={
                                        equipment.branchVendorValue
                                          ? {
                                              value:
                                                equipment.branchVendorValue,
                                              label: equipment.branchVendorName,
                                            }
                                          : ""
                                      }
                                      options={branchOptions}
                                      onChange={(e) =>
                                        equipmentChange(
                                          e,
                                          index,
                                          "branchVendorValue"
                                        )
                                      }
                                      isDisabled={
                                        equipmentHistoryViewModal == true
                                          ? true
                                          : false
                                      }
                                      placeholder="Select Branch Vendor"
                                      classNamePrefix="select2-selection"
                                    />
                                    {simpleValidator.current.message(
                                      "branchVendorValue",
                                      equipment.branchVendorValue,
                                      "required"
                                    )}
                                  </>
                                )}
                              </td>
                              <td>
                                <Select
                                  // type="text"
                                  name="serviceNameValue"
                                  value={
                                    equipment.serviceNameValue
                                      ? {
                                          value: equipment.serviceNameValue,
                                          label: equipment.serviceName,
                                        }
                                      : ""
                                  }
                                  isDisabled={
                                    equipmentHistoryViewModal == true
                                      ? true
                                      : false
                                  }
                                  options={
                                    !isEmpty(serviceListOptions)
                                      ? serviceListOptions
                                      : []
                                  }
                                  onChange={(e) =>
                                    equipmentChange(
                                      e,
                                      index,
                                      "serviceNameValue"
                                    )
                                  }
                                  placeholder="Select Service"
                                  classNamePrefix="select2-selection"
                                />
                                {simpleValidator.current.message(
                                  "serviceNameValue",
                                  equipment.serviceNameValue,
                                  "required"
                                )}
                              </td>
                              <td>
                                <div className="d-flex flex-row">
                                  <Col md="10" lg="10" xl="10" sm="10" xs="10">
                                    <Select
                                      // type="text"
                                      name="equipmentId"
                                      value={
                                        equipment.equipmentId
                                          ? {
                                              value: equipment.equipmentId,
                                              label: equipment.equipmentName,
                                            }
                                          : ""
                                      }
                                      isDisabled={
                                        equipmentHistoryViewModal == true ||
                                        isEmpty(equipment.branchVendorValue)
                                          ? true
                                          : false
                                      }
                                      options={equipmentMasterOptions}
                                      onChange={(e) =>
                                        equipmentChange(e, index, "equipmentId")
                                      }
                                      placeholder="Select Equipment"
                                      classNamePrefix="select2-selection"
                                    />
                                    {simpleValidator.current.message(
                                      "equipmentId",
                                      equipment.equipmentId,
                                      "required"
                                    )}
                                  </Col>
                                  <Col md="2" lg="2" xl="2" sm="2" xs="2">
                                    <i
                                      className={
                                        equipmentHistoryViewModal == true ||
                                        equipment.scheduleTypeValue ===
                                          "Vendor" ||
                                        isEmpty(equipment.branchVendorValue)
                                          ? "disabled-button fas fa-eye mx-2 icon-btn equipment-name-list-eye-icon mx-1"
                                          : "fas fa-eye mx-2 icon-btn equipment-name-list-eye-icon mx-1"
                                      }
                                      style={{
                                        alignItems: "center",
                                        color: "#50a5f1",
                                        marginTop: "10px",
                                      }}
                                      onClick={() => {
                                        setEquipmentVacancyModal(true)
                                        // setEquipmentHistoryDetails(data)
                                        setVacancyEquipmentDetails(
                                          equipmentData
                                        )
                                        setSelectedAgentData(
                                          equipment.equipmentId
                                        )

                                        setVacancyId(equipment._id)
                                        // setOfficeSelectionDetails(
                                        //   ""
                                        // )
                                        setVacancyIndex(equipment.index)
                                        setFullscreen(true)
                                      }}
                                    ></i>
                                  </Col>
                                </div>
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  name="quantity"
                                  // disabled={equipmentHistoryViewModal == true ? true : false}
                                  value={equipment.quantity}
                                  onChange={(e) =>
                                    equipmentChange(e, index, "quantity")
                                  }
                                  placeholder="Enter Quantity"
                                />
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  name="cost"
                                  // disabled={equipmentHistoryViewModal == true ? true : false}
                                  value={equipment.cost}
                                  onChange={(e) =>
                                    equipmentChange(e, index, "cost")
                                  }
                                  placeholder="Enter Cost"
                                />
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  name="totalAmount"
                                  // disabled={equipmentHistoryViewModal == true ? true : false}
                                  value={equipment.totalAmount}
                                  onChange={(e) =>
                                    equipmentChange(e, index, "totalAmount")
                                  }
                                  placeholder="Enter Total Amount"
                                />
                              </td>
                              {removeEquipment ? (
                                <td style={{ textAlign: "center" }}>
                                  <i
                                    className="fa fa-times remove-icon"
                                    onClick={() =>
                                      removeEquipmentDetails(index)
                                    }
                                  ></i>
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          )
                        })
                      ) : (
                        <tr key={0}>
                          <td colSpan={8} className="text-align-center">
                            No Records Found..
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  className="btn btn-danger"
                  // disabled={equipmentHistoryViewModal == true ? true : false}
                  onClick={() => {
                    setEquipmentData(equipmentData)
                    setHistoryModal(false)
                    setEquipmentHistoryViewModal(false)
                  }}
                >
                  Close
                </Button>

                {updateEquipmentModal ? (
                  <Button
                    className="btn btn-success mx-2"
                    onClick={() => updateEquipmentDetails()}
                    disabled={equipmentHistoryViewModal == true ? true : false}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    className="btn btn-success mx-2"
                    type="submit"
                    onClick={(e) => addEquipmentDetails(e)}
                    disabled={equipmentHistoryViewModal == true ? true : false}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {equipmentVacancyModal && (
          <Modal
            show={equipmentVacancyModal}
            onHide={handleEquipmentModalClose}
            fullscreen={fullscreen}
          >
            {/* <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col md="12" lg="12" sm="12">
                
              </Col>
            </Modal.Header> */}
            <Modal.Body>
              <Row className="mt-2 mb-3">
                {/* <Col md="2" lg="2" sm="2">
                  <Button
                    className="btn btn-success"
                    onClick={() => equipmentVacancySearch()}
                  >
                   
                    Search
                  </Button>
                </Col> */}
                <Col md="12" lg="12" sm="12">
                  <div style={{ textAlign: "center" }}>
                    <h1>
                      {!isEmpty(equipmentVacantMonth)
                        ? equipmentVacantMonthName
                        : currentMonth}{" "}
                      -{" "}
                      {!isEmpty(equipmentVacantYear)
                        ? equipmentVacantYear
                        : year}
                    </h1>
                  </div>

                  <div style={{ float: "right", marginTop: "-33px" }}>
                    <span>
                      <i
                        className="fa fa-times quote-close font-size-14"
                        aria-hidden="true"
                        onClick={() => setEquipmentVacancyModal(false)}
                      ></i>
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="3" lg="3" sm="3">
                  <ReactSearchAutocomplete
                    name="equipmentVacancy"
                    items={equipmentOptions}
                    value={equipmentVacancy}
                    type="autoComplete"
                    resultStringKeyName="label"
                    showIcon={false}
                    onSelect={(e) => setEquipmentVacancy(e)}
                    onChange={(e) => setEquipmentVacancy(e.target.value)}
                    placeholder="Search Equipment"
                    fuseOptions={fuseOptions} // Search on both fields
                    styling={{
                      height: "34px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      width: "140px",
                      backgroundColor: "white",
                      boxShadow: "none",
                      hoverBackgroundColor: "#E40D8C",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Courier",
                      iconColor: "green",
                      clearIconMargin: "3px 8px 0 0",
                      zIndex: 10,
                    }}
                  />
                </Col>
                <Col md="3" lg="3" sm="3">
                  <Input
                    type="date"
                    name="equipmentEventDate"
                    value={equipmentEventDate}
                    onChange={(e) => setEquipmentEventDate(e.target.value)}
                    placeholder="Select Date"
                  />
                </Col>
                <Col md="2" lg="2" sm="2">
                  <Button
                    className="btn btn-success"
                    onClick={() => equipmentVacancySearch()}
                  >
                    {/* <i
                        className="fa fa-search"
                        // style={{
                        //   // marginLeft: "-25px",
                        //   marginTop: "10px",
                        //   color: "blue",
                        // }}
                      ></i> */}
                    Search
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm="12" md="12" lg="12">
                  <Table>
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        overflowY: "auto",
                        background: "#ffffff",
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            position: "sticky",
                            background: "#ffffff",
                            top: 0,
                            overflowX: "auto",
                          }}
                        >
                          Equipment Brand
                        </th>
                        {!isEmpty(equipment_vacancy_details) &&
                        equipment_vacancy_details.length > 0
                          ? Object.entries(equipment_vacancy_details).map(
                              ([key, value]) => {
                                return (
                                  <th
                                    key={key}
                                    style={{
                                      color:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#ffffff"
                                          : "#47d56c",
                                      fontWeight: 450,
                                      fontSize: "13px",
                                      background:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#af2476"
                                          : "#ffffff",
                                    }}
                                    className="header-fixed"
                                  >
                                    {value.equipmentBrandName}
                                  </th>
                                )
                              }
                            )
                          : []}
                      </tr>
                      <tr>
                        <th
                          style={{
                            position: "sticky",
                            background: "#ffffff",
                            top: 0,
                            overflowX: "auto",
                          }}
                        >
                          Equipment Type
                        </th>
                        {!isEmpty(equipment_vacancy_details) &&
                        equipment_vacancy_details.length > 0
                          ? Object.entries(equipment_vacancy_details).map(
                              ([key, value]) => {
                                return (
                                  <th
                                    className="header-fixed"
                                    key={key}
                                    style={{
                                      color:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#ffffff"
                                          : "#47d56c",
                                      fontWeight: 450,
                                      fontSize: "13px",
                                      background:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#af2476"
                                          : "#ffffff",
                                    }}
                                  >
                                    {value.equipmentTypeName}
                                  </th>
                                )
                              }
                            )
                          : []}
                      </tr>
                      <tr>
                        <th
                          style={{
                            position: "sticky",
                            background: "#ffffff",
                            top: 0,
                            overflowX: "auto",
                          }}
                        >
                          Product Version
                        </th>
                        {!isEmpty(equipment_vacancy_details) &&
                        equipment_vacancy_details.length > 0
                          ? Object.entries(equipment_vacancy_details).map(
                              ([key, value]) => {
                                return (
                                  <th
                                    className="header-fixed"
                                    key={key}
                                    style={{
                                      color:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#ffffff"
                                          : "#47d56c",
                                      fontWeight: 450,
                                      fontSize: "13px",
                                      background:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#af2476"
                                          : "#ffffff",
                                    }}
                                  >
                                    {value.productVersionName}
                                  </th>
                                )
                              }
                            )
                          : []}
                      </tr>
                      <tr>
                        <th
                          style={{
                            position: "sticky",
                            background: "#ffffff",
                            top: 0,
                            overflowX: "auto",
                          }}
                        >
                          Serial No
                        </th>
                        {!isEmpty(equipment_vacancy_details) &&
                        equipment_vacancy_details.length > 0
                          ? Object.entries(equipment_vacancy_details).map(
                              ([key, value]) => {
                                return (
                                  <th
                                    className="header-fixed"
                                    key={key}
                                    style={{
                                      color:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#ffffff"
                                          : "#47d56c",
                                      fontWeight: 450,
                                      fontSize: "13px",
                                      background:
                                        value.equipmentMasterId ===
                                        selectedAgentData
                                          ? "#af2476"
                                          : "#ffffff",
                                    }}
                                  >
                                    {value.serialNumber}
                                  </th>
                                )
                              }
                            )
                          : []}
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(equipment_office_details) &&
                      equipment_office_details &&
                      equipment_office_details.length > 0
                        ? equipment_office_details.map((data, index) => {
                            const equipmentVacancyDate = !isEmpty(data)
                              ? moment(data.date).format("DD-MM-YYYY")
                              : ""
                            console.log(
                              equipmentVacancyDate,
                              "equipmentVacancyDate"
                            )
                            return (
                              <tr
                                key={index}
                                style={{
                                  color: "#4fccd9",
                                  fontWeight: 450,
                                  fontSize: "13px",
                                  width: "80px",
                                  // overflowY: "hidden"
                                }}
                                // className="header-fixed"
                              >
                                {/* <td style={{position: "sticky",background: "#ffffff", left: 0,}}> {data.date}</td> */}
                                <td
                                  style={{
                                    color:
                                      eventDate === equipmentVacancyDate
                                        ? "#ffffff"
                                        : "#47d56c",
                                    fontWeight: 450,
                                    fontSize: "13px",
                                    background:
                                      eventDate === equipmentVacancyDate
                                        ? "#af2476"
                                        : "#ffffff",
                                  }}
                                >
                                  {" "}
                                  {data.date}
                                </td>

                                {data.detail.map((office, index) => {
                                  return (
                                    <td
                                      style={{
                                        color:
                                          office.isSchedule === false &&
                                          eventDate === equipmentVacancyDate
                                            ? "#ffffff"
                                            : office.isSchedule === false &&
                                              eventDate !== equipmentVacancyDate
                                            ? "#E40D8C"
                                            : "#f1b44c",
                                        fontWeight: 450,
                                        fontSize: "13px",
                                        background:
                                          eventDate === equipmentVacancyDate
                                            ? "#af2476"
                                            : "#ffffff",
                                      }}
                                      key={index}
                                      onClick={() => {
                                        // if (office.isSchedule === false) {
                                        officeEditDetails(office)
                                        // }
                                        // setEquipmentVacancyModal(false)
                                      }}
                                    >
                                      {office.isSchedule === false
                                        ? "OPEN"
                                        : office.schedule}
                                    </td>
                                  )
                                })}
                              </tr>
                            )
                          })
                        : []}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setEquipmentVacancyModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {eventFinalCommitModal && (
          <Modal
            show={eventFinalCommitModal}
            onHide={handleFinalEventCommitModal}
            size="md"
            // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>Do you want to commit the Event ?</Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setEventFinalCommitModal(false)}
              >
                Close
              </Button>
              <Button
                type="button"
                className="btn btn-success"
                onClick={() => eventFinalCommit()}
              >
                Commit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {finalCommitModal && (
          <Modal
            show={finalCommitModal}
            onHide={handleFinalCommitModal}
            size="md"
            // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>Do you want to commit the Event ?</Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setFinalCommitModal(false)}
              >
                Close
              </Button>
              <Button className="btn btn-success" onClick={() => finalCommit()}>
                Commit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {eventSameModal && (
          <Modal
            show={eventSameModal}
            onHide={handleEventSameModal}
            size="md"
            // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>Do you want to confirm the same as event ?</Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setEventSameModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-success"
                onClick={() => {
                  setEventSameAsModal(true)
                  setEventSameModal(false)
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}
EquipmentScheduling.propTypes = {
  dispatch: PropTypes.func,
  clientProfile: PropTypes.any,
  modeMenu: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentScheduling)
)
